import { createElement } from "react";
/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';
const closeSmall = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, createElement(Path, {
  d: "M12 13.06l3.712 3.713 1.061-1.06L13.061 12l3.712-3.712-1.06-1.06L12 10.938 8.288 7.227l-1.061 1.06L10.939 12l-3.712 3.712 1.06 1.061L12 13.061z"
}));
export default closeSmall;
//# sourceMappingURL=close-small.js.map